<div class="card card-nb h-100 rounded-4">
    <div class="card-body pb-0 d-flex flex-column">
        <div class="d-flex flex-row">
            <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-2">
                    <img src="{{integrationApp.iconUrl}}" alt="Integration App Icon" 
                      style="max-width: 100px; max-height: 100px; border-radius: 10px;">
                </div>
                <span class="font-weight-bold">{{integrationApp.name}}</span>
                <span class="subinformations"
                    [innerHTML]="'integration-apps-card_display_vendor' | i18next: { vendor: integrationApp.vendor }"></span>
            </div>
            <div class="d-flex flex-row ml-auto">
                @if (installationState) {
                  <span class="mr-3" style="color: #faab00">{{ integrationService.getInstallationStateLabelKey(installationState) | i18next }}</span>
                }
                <ng-content select="[titlemenu]"></ng-content>
            </div>
        </div>
        <hr class="mt-auto">
        <div class="d-flex flex-row justify-content-between align-items-center mb-3" style="height: 50px;">
            @if (integrationApp.marketplaceVisibility === MarketplaceVisibility.MARKETPLACEVISIBILITY_VISIBLE) {
                <div class="d-flex flex-row align-items-center subinformations">
                    <i class="fa fa-store fa-xl mr-2"></i>
                    <span>{{'integration-apps-card_marketplace_visible' | i18next}}</span>
                </div>
            }
            @if (integrationApp.marketplaceVisibility === MarketplaceVisibility.MARKETPLACEVISIBILITY_INVISIBLE) {
                <div class="d-flex flex-row align-items-center subinformations">
                    <i class="fa fa-store-slash fa-xl mr-2"></i>
                    <span>{{'integration-apps-card_marketplace_invisible' | i18next}}</span>
                </div>
            }
            @if (isAlreadyInstalled) {
                <span class="green">{{'integration-apps-card_already_installed_hint' | i18next}}</span>
            } @else {
                <button class="btn btn-outline-primary" [routerLink]="['/integration-apps/details', integrationApp.uuid]"
                    [queryParams]="{ preselectedSubId: preselectedSubId, preselectedSubName: preselectedSubName }">{{'app_details' | i18next}}</button>
            }
        </div>
    </div>
</div>